import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-me-password",
  "use": "icon-me-password-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-me-password\"><defs><style type=\"text/css\"></style></defs><path d=\"M866.329807 354.473707h-708.694309A78.715689 78.715689 0 0 0 78.793256 433.252673v433.12612a157.494655 157.494655 0 0 0 157.494655 157.494654H787.487565a157.494655 157.494655 0 0 0 157.494655-157.494654V433.252673a78.778966 78.778966 0 0 0-78.652413-78.778966z m-314.98931 413.447198a39.357845 39.357845 0 0 1-78.778966 0V610.42625a39.357845 39.357845 0 0 1 78.778966 0z\" p-id=\"16654\" /><path d=\"M511.919376 78.842242a197.042328 197.042328 0 0 1 196.852499 196.852499V354.410431H315.0036V275.631465a197.042328 197.042328 0 0 1 196.8525-196.852499m0-78.778966a275.631465 275.631465 0 0 0-275.568189 275.694741v157.494655h551.26293V275.694741A275.631465 275.631465 0 0 0 511.919376 0.063276z\" p-id=\"16655\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/me-password.svg
// module id = HgDJ
// module chunks = 7